import registry from './registry';
import { showNotification } from '../pages/components/Notification';

// Example: Registering Navigation Services
export const registerNavigationServices = (navigate) => {
    registry.register('nav.helpdesk', () => navigate('/helpdesk'), { description: 'Go to Helpdesk' });
    registry.register('nav.dashboard', () => navigate('/dashboard'), { description: 'Go to Dashboard' });
    registry.register('nav.settings', () => navigate('/settings'), { description: 'Go to Settings' });
};

// Example: Registering UI Actions (to be called by pages)
export const registerUIServices = () => {
    registry.register('ui.show_toast', (msg) => showNotification(msg, 'success'), { description: 'Show a notification message' });
};
